import React, { useEffect, useState } from 'react';
import './App.css';
import { getDailyWebsiteStats, DailyWebsiteStats } from './api';
import VisitorChart from './components/VisitorChart';

/**
 * App组件是网站访客统计管理面板的主组件。
 * 负责获取和展示访客数据，包括访客日志列表和访问量图表。
 */
function App() {
  // 每日网站统计数据
  const [dailyStats, setDailyStats] = useState<DailyWebsiteStats[]>([]);

  /**
   * 副作用钩子，获取每日网站统计数据。
   */
  useEffect(() => {
    const fetchDailyStats = async () => {
      try {
        const stats = await getDailyWebsiteStats();
        setDailyStats(stats);
      } catch (error) {
        console.error("获取每日统计数据时出错:", error);
      }
    };

    fetchDailyStats();
  }, []); // 不再依赖 websiteId，因为获取的是所有网站的统计

  /**
   * 将每日统计数据按网站ID分组。
   * @param stats 每日网站统计数据数组
   * @returns 按 websiteId 分组的数据
   */
  const groupStatsByWebsite = (stats: DailyWebsiteStats[]) => {
    const grouped: { [key: string]: { date: string; count: number }[] } = {};
    stats.forEach(item => {
      if (!grouped[item.websiteId]) {
        grouped[item.websiteId] = [];
      }
      grouped[item.websiteId].push({ date: item.date, count: item.count });
    });
    return grouped;
  };

  const groupedDailyStats = groupStatsByWebsite(dailyStats);

  return (
    <div className="App">
      <header className="App-header">
        <h1>网站访客统计管理面板</h1>
      </header>
      <main>
        {Object.keys(groupedDailyStats).map(websiteId => (
          <div key={websiteId}>
            <h2>网站: {websiteId} - 每日访问量</h2>
            <VisitorChart data={groupedDailyStats[websiteId]} />
          </div>
        ))}
      </main>
    </div>
  );
}

export default App;
